import { Suspense, lazy } from 'react'
import { Switch, Redirect, Route } from 'react-router-dom'
import { common } from '@ocean/ui'
import trainingLibraryRoutes from 'modules/trainingLibrary/TrainingLibrary/routing/routes'
import routes from './routes'

const { RouteChangeProgress } = common

export { routes }

export const EducationDetails = lazy(
  () =>
    import(
      /* webpackChunkName: "ActivityDetailsEducationDetails" */ 'modules/activityDetails/EducationDetails/pages/EducationDetails'
    )
)

const EducationDetailsRouting = () => (
  <Suspense fallback={<RouteChangeProgress />}>
    <Switch>
      <Route exact path={`${routes.root}/:educationId`} component={EducationDetails} />
      <Redirect path='*' to={trainingLibraryRoutes.root} />
    </Switch>
  </Suspense>
)

export default EducationDetailsRouting
